/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import AuthenticationPasswordForm from 'src/shared/app/authentication/component/base/AuthenticationPasswordForm';
import logInMessages from 'src/shared/app/authentication/l10n/logInL10n';
import useEventBraindateName from 'src/shared/domain/event/hook/useEventBraindateName';

type Props = {
  type: ?string,
  legend: ?string,
  label: ?string,
  placeholder: ?string,
  note: ?string,
  handleSubmit: (Object) => Promise<any>,
  isPasswordSet: boolean,
  forgotPasswordURL?: string,
  // Self passed
  intl: intlShape,
};

const LoginPasswordFormDumb = ({
  type,
  legend,
  label,
  placeholder,
  note,
  handleSubmit,
  isPasswordSet,
  forgotPasswordURL,
  intl,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const { braindatePlatform: platform } = useEventBraindateName();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return (
    <AuthenticationPasswordForm
      type={type}
      legend={
        legend ||
        intl.formatMessage(
          logInMessages[isPasswordSet ? 'passwordLegend' : 'newPasswordLegend'],
          { platform },
        )
      }
      label={
        isPasswordSet
          ? label
          : intl.formatMessage(logInMessages.newPasswordLabel, {
              platform,
            })
      }
      placeholder={placeholder}
      note={note}
      submitCta={intl.formatMessage(logInMessages.passwordSubmit)}
      handleSubmit={handleSubmit}
      isPasswordSet={isPasswordSet}
      forgotPasswordURL={forgotPasswordURL}
    />
  );
};

export default compose(React.memo, injectIntl)(LoginPasswordFormDumb);
